import React from 'react';

import { ISO_DATE_FORMAT } from '@gasbi/shared';
import dayjs from 'dayjs';
import { Navigate } from 'react-router-dom';

import { Pages } from '@/pages';

const AllocationActualLayout = React.lazy(() => import('./index'));
const Import = React.lazy(() => import('./views/import/Import'));
const ImportDetail = React.lazy(
  () => import('./views/ImportDetail/ImportDetail'),
);
const Result = React.lazy(() => import('./views/Result/Result'));
const OperatorDetail = React.lazy(() => import('./views/OperatorDetail'));

const allocationActualRoute = [
  {
    element: <AllocationActualLayout />,
    children: [
      {
        path: Pages.ALLOCATION_ACTUAL,
        element: (
          <Navigate
            to={`./${dayjs().startOf('month').format(ISO_DATE_FORMAT)}`}
            relative='path'
          />
        ),
      },
      {
        path: `${Pages.ALLOCATION_ACTUAL}/:date`,
        element: <Import />,
      },
      {
        path: `${Pages.ALLOCATION_ACTUAL}/:date/${Pages.ALLOCATION_ACTUAL_RESULT}`,
        element: <Result />,
      },
    ],
  },
  {
    path: `${Pages.ALLOCATION_ACTUAL}/:date/${Pages.ALLOCATION_ACTUAL_IMPORT_DETAIL}`,
    element: <ImportDetail />,
  },
  {
    path: `${Pages.ALLOCATION_ACTUAL}/:date/${Pages.ALLOCATION_ACTUAL_RESULT}/${Pages.ALLOCATION_ACTUAL_OPERATOR_DETAIL}`,
    element: <OperatorDetail />,
  },
];

export default allocationActualRoute;
